import { Outlet, createRootRoute } from '@tanstack/react-router'
import QueryClientProvider from '@/providers/QueryClientProvider'
import Web3Provider from '@/providers/Web3Provider'
import ThemeProvider from '@/providers/ThemeProvider'
import OperatorSessionProvider from '@/providers/OperatorSessionProvider'
import { AppShell } from '@/components/layout/AppShell'
import { RequireOperatorRole } from '@/components/auth/RequireOperatorRole'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from '@/components/ui/sonner'
import { ContractIdentityWatcher } from '@/components/layout/ContractIdentityWatcher'

function RootComponent() {
    return (
        <ThemeProvider>
            <QueryClientProvider>
                <Web3Provider>
                    <OperatorSessionProvider>
                        <TooltipProvider>
                            <ContractIdentityWatcher />
                            <RequireOperatorRole>
                                <AppShell>
                                    <Outlet />
                                </AppShell>
                            </RequireOperatorRole>
                            <Toaster />
                        </TooltipProvider>
                    </OperatorSessionProvider>
                </Web3Provider>
            </QueryClientProvider>
        </ThemeProvider>
    )
}

export const Route = createRootRoute({
    component: RootComponent,
})
